module.exports = __webpack_public_path__ + "img/card-error.79aa3e68.svg";